import {ArianeElement, ArianeStore} from "@digicerba/common";
import {Component} from "@angular/core";
import {CanalNotificationWithSubscribeInformationDto, INotificationsWebServiceClient} from "@resources/resources";
import {ActivatedRoute} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'gestion-alertes',
  templateUrl: './gestion-alertes.component.html',
  host: {'class': 'page'}
})
export class GestionAlertesComponent {

  canaux: CanalNotificationWithSubscribeInformationDto[];

  constructor(arianeStore: ArianeStore, private notificationsWebServiceClient: INotificationsWebServiceClient,
              private activatedRoute: ActivatedRoute, private translateService: TranslateService) {
    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: "ARIANE.HOME",
        route: "/alertes"
      },
      {
        libelle: "ARIANE.GESTION",
        route: "/"
      }
    ]
    arianeStore.updateElements(arianeElements);
    this.canaux = this.activatedRoute.snapshot.data['canaux'];
  }

  public getCanalSubscribedLabel(canal: CanalNotificationWithSubscribeInformationDto): string {
    return canal.subscribed ? this.translateService.instant("CANAUX.actif") : this.translateService.instant("CANAUX.inactif");
  }

  public setCanalSubscribed(isSubscribed: boolean, idCanal: number): void {
    if (isSubscribed) {
      this.notificationsWebServiceClient.subscribeToCanalNotification(idCanal).subscribe(() => {
        console.log("souscription au canal : " + idCanal);
      });
    } else {
      this.notificationsWebServiceClient.unsubscribeToCanalNotification(idCanal).subscribe(() => {
        console.log("desinscription du canal : " + idCanal);
      });
      ;
    }
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/src/app/pages/cerba/pages/alertes/canaux/gestion/gestion-alertes.component.ts